/**
 * Модель данных подписи файла
 */
export class SignData {
    public readonly id: string;
    public readonly created_at: string;
    public readonly created_by: string;
    public readonly created_by_id: string;
    public readonly file_id: string;
    public readonly lastname: string;
    public readonly owner: string;
    public readonly publisher: string;
    public readonly roles: string;
    public readonly sign: string;
    public readonly valid_to: string;
    public readonly type: string;
    public readonly status: string;
    public readonly is_valid: boolean;
    constructor(data: any) {
        this.id = data?.id ?? '';
        this.created_at = data?.created_at ?? '';
        this.created_by = data?.created_by ?? '';
        this.created_by_id = data?.created_by_id ?? '';
        this.file_id = data?.file_id ?? '';
        this.valid_to = data?.valid_to ?? '';
        this.lastname = data?.lastname ?? '';
        this.owner = data?.owner ?? '';
        this.publisher = data?.publisher ?? '';
        this.roles = data?.roles ?? '';
        this.sign = data?.sign ?? '';
        this.type = data?.type ?? '';
        this.status = data?.status ?? '';
        this.is_valid = data.hasOwnProperty('is_valid') ? Number(data.is_valid) === 1 : true;
    }
}
